import axios from 'axios';
import Cookies from './Cookies';
import { BucketAssignment } from '../SharedTypes';
import { API_TIMEOUT } from '../constants';

type AbTestResponse = {
  data?: {
    bucketName: string;
  };
};

const bucketFromResult = (result: AbTestResponse, options) => {
  const {
    name: experimentName
  } = options;
  const {
    data: { bucketName = undefined } = {}
  } = result;

  return {
    assignedBucket: bucketName,
    experimentName
  };
};

const endpoints = {
  development: {
    dotcomUrl: 'devazure.carvana.com',
  },
  test: {
    dotcomUrl: 'testazure.carvana.com',
  },
  uat: {
    dotcomUrl: 'uatazure.carvana.com',
  },
  production: {
    dotcomUrl: 'carvana.com',
  },
  unknown: {
    dotcomUrl: '',
  },
};

export default (async function FetchExperimentByName(options): Promise<BucketAssignment> {
  const {
    name: experimentName,
    cacheMinutes = 15,
    killSwitch,
    environment = process.env.NODE_ENV || 'development',
  } = options;
  if (killSwitch === 'on') return bucketFromResult({}, options);

  return axios({
    method: 'POST',
    url: `https://${endpoints[environment].dotcomUrl}/api/ab-tests/experiment-bucket`,
    timeout: API_TIMEOUT,
    data: { experimentName }
  }).then(response => {
    if (cacheMinutes !== 0 && response.data.bucketName) {
      Cookies.set(experimentName, response.data.bucketName, cacheMinutes);
    }
    return bucketFromResult(response, options);
  }).catch(() => bucketFromResult({}, options));
});
